var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoActivites1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2_00000077306916178051885110000012158661192331787162_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7,58h-6.1c-0.5,0-1-0.5-1-1V27.2h-35V57c0,0.5-0.5,1-1,1H7.3c-0.5,0-1-0.5-1-1V23.4c0-1.5,0.9-2.9,2.1-3.6L29.3,8.2 c1.7-1,3.8-1,5.5,0l20.9,11.6c1.3,0.7,2.1,2.1,2.1,3.6v33.7C57.7,57.6,57.1,58,56.7,58z M51.5,55.9h4.1V23.4c0-0.7-0.4-1.4-1-1.7 l-21-11.8c-1-0.7-2.4-0.7-3.6,0L9.2,21.5c-0.7,0.4-1,1-1,1.7v32.7h4.1V26.2c0-0.5,0.5-1,1-1h36.9c0.5,0,1,0.5,1,1L51.5,55.9z  M36.6,46.7h-8.2v-8.2c0-0.5-0.5-1-1-1h-9.3c-0.5,0-1,0.5-1,1v9.3v9.3c0,0.5,0.5,1,1,1h9.3h9.3c0.5,0,1-0.5,1-1v-9.4 C37.7,47.2,37.1,46.7,36.6,46.7z M19.2,39.5h7.2v7.2h-7.2V39.5z M19.2,48.7h7.2v7.2h-7.2V48.7z M35.6,55.9h-7.2v-7.2h7.2V55.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoActivites1);
export default __webpack_public_path__ + "static/media/picto-activites-1.1392a5b7b4462e986cef5ea0d946786b.svg";
export { ForwardRef as ReactComponent };